import e from "./index27.js";
import { defineComponent as t } from "vue";
const i = t({
  name: "Disclaimer",
  components: {
    DisclaimerDesktop: e
  },
  props: {
    settings: {
      type: Object,
      required: !0
    },
    isSimpleStyle: {
      type: Boolean,
      default: !1
    },
    isQuebec: {
      type: Boolean,
      default: !1
    }
  }
});
export {
  i as default
};
//# sourceMappingURL=index23.js.map
